

















































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import IndicatorModel from "@/models/indicator/indicator.model";
import { PermissionValue } from "@/enums/PermissionValue";
@Component
export default class IndicatorTableComponent extends GenericBTable<IndicatorModel> {
isFirstTime = true;
  created() {
    this.permissionValue = PermissionValue.CODIFICACIONES;
    this.tableConfig.controller = "Indicators"
    this.tableConfig.whereParams = `indicatorTypeId eq ${this.$route.params.indicatorTypeId}`
    this.formatColumns();
  }
  @Watch("tableConfig.data")
      onDataChange(){
        if(this.isFirstTime){
          this.tableConfig.data =  this.tableConfig.data.filter(x => !x.indicatorFatherId)
        }
        this.isFirstTime = false;
      }

  formatColumns() {
    let name = new BTableColumn("name", "Indicador", false);
    let indicadorNo = new BTableColumn("indicadorNo", "No. Indicador", false);

    this.tableConfig.insertColumns(name,indicadorNo);
    this.tableConfig.actions.customTemplate = true;
  }
  verOpciones(row: any) {
    this.$router.push(`indicatorGroup/${Number(this.$route.params.indicatorGroupId)}/indicatorType/${Number(this.$route.params.indicatorTypeId)}/indicator/${row.id}`)
  }
}
